import { useEffect } from "react";
export default function ChatwootWidget({ websiteToken, baseUrl = "https://app.chatwoot.com", userEmail, userName, userId, hideMessageBubble = false, zIndex, }) {
    // Handle z-index override for all Chatwoot elements
    useEffect(() => {
        if (zIndex === undefined)
            return;
        const applyZIndex = () => {
            // Target all known Chatwoot elements
            const selectors = [
                "#cw-bubble-holder",
                "#chatwoot-widget-holder",
                ".woot-widget-holder",
                ".woot--bubble-holder",
            ];
            selectors.forEach((selector) => {
                const el = document.querySelector(selector);
                if (el) {
                    el.style.zIndex = String(zIndex);
                }
            });
        };
        // Apply immediately
        applyZIndex();
        // Apply when chatwoot is ready
        window.addEventListener("chatwoot:ready", applyZIndex);
        // Also observe DOM changes as fallback
        const observer = new MutationObserver(applyZIndex);
        observer.observe(document.body, { childList: true, subtree: true });
        return () => {
            window.removeEventListener("chatwoot:ready", applyZIndex);
            observer.disconnect();
        };
    }, [zIndex]);
    useEffect(() => {
        // Check if script is already loaded
        if (window.chatwootSDK) {
            // If SDK is already loaded, just set user info
            if (window.$chatwoot && userId) {
                const userData = {};
                if (userEmail)
                    userData.email = userEmail;
                if (userName)
                    userData.name = userName;
                window.$chatwoot.setUser(userId, userData);
            }
            return;
        }
        if (!websiteToken) {
            console.error("No Chatwoot website token provided");
            return;
        }
        // Set user info in global scope BEFORE initializing SDK
        // This is critical - Chatwoot needs this before SDK.run()
        window.chatwootSettings = {
            hideMessageBubble,
            position: "right",
            locale: "en",
            type: "expanded_bubble",
            showUnreadMessagesDialog: false,
        };
        // Create and inject the Chatwoot script
        const script = document.createElement("script");
        script.src = `${baseUrl}/packs/js/sdk.js`;
        script.async = true;
        script.onload = () => {
            if (window.chatwootSDK) {
                window.chatwootSDK.run({
                    websiteToken,
                    baseUrl,
                });
                // Listen for chatwoot:ready event before setting user
                window.addEventListener("chatwoot:ready", () => {
                    if (userId && window.$chatwoot) {
                        const userData = {};
                        if (userEmail)
                            userData.email = userEmail;
                        if (userName)
                            userData.name = userName;
                        window.$chatwoot.setUser(userId, userData);
                    }
                });
            }
        };
        script.onerror = (error) => {
            console.error("Failed to load Chatwoot script", error);
        };
        const firstScript = document.getElementsByTagName("script")[0];
        firstScript.parentNode?.insertBefore(script, firstScript);
        // Cleanup function to remove script if component unmounts
        return () => {
            script.remove();
        };
    }, [websiteToken, baseUrl, userId, userEmail, userName]);
    return null;
}
